/**
 * 远期房态：前端直调 getAliasPriceQuantity + 本地缓存，供 useLoadingStoreData 合并
 * 先读 localStorage 展示，再按需后台刷新，有缓存时不显示 loading 动画
 */
import { useState, useCallback, useEffect } from 'react';
import { getRoomStatusRecentlyWithCache, getRoomStatusRecentlyFromLocalStorageSync, } from '../utils/roomStatusRecentlyCache';
import { getFutureRoomStatusListWithCache } from '../utils/futureRoomStatusCache';
export function useRoomStatusRecentlyFromApi(storeId, options) {
    var enabled = (options === null || options === void 0 ? void 0 : options.enabled) !== false;
    var _a = useState(function () {
        if (!enabled)
            return null;
        if (storeId == null)
            return null;
        var base = getRoomStatusRecentlyFromLocalStorageSync(storeId);
        return base ? { baseChartData: base } : null;
    }), data = _a[0], setData = _a[1];
    var _b = useState(function () {
        if (!enabled)
            return false;
        if (storeId == null)
            return false;
        return !getRoomStatusRecentlyFromLocalStorageSync(storeId);
    }), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var _d = useState(0), refreshKey = _d[0], setRefreshKey = _d[1];
    var refresh = useCallback(function () { return setRefreshKey(function (k) { return k + 1; }); }, []);
    useEffect(function () {
        if (!enabled) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }
        if (storeId == null) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }
        var cancelled = false;
        if (!getRoomStatusRecentlyFromLocalStorageSync(storeId))
            setLoading(true);
        setError(null);
        // 顺带拉取 FSM 远期房态，写入本地缓存（2 分钟），供图表展示已占用/可售房量
        getFutureRoomStatusListWithCache(storeId).catch(function () { });
        getRoomStatusRecentlyWithCache(storeId)
            .then(function (baseChartData) {
            if (!cancelled) {
                setData({ baseChartData: baseChartData });
                setError(null);
            }
        })
            .catch(function (err) {
            if (!cancelled) {
                setError(err instanceof Error ? err : new Error(String(err)));
                setData(null);
            }
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [storeId, refreshKey, enabled]);
    return { data: data, loading: loading, error: error, refresh: refresh };
}
